'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider
    .state('main', {
      url: '/',
      template: '<main></main>'
    })
    .state('bus-list', {
      url: '/車両紹介',
      template: '<bus-list></bus-list>'
    })
    .state('bus-detail', {
      url: '/車両紹介/:busId',
      template: '<bus-detail></bus-detail>'
    })
    .state('service', {
      abstract: true,
      url: '/サービス',
      template: '<service></service>'
    })
    .state('service.strength', {
      url: '/',
      template: '<strength></strength>'
    })
    .state('service.prevention', {
      url: '/新型コロナ感染防止対策',
      template: '<prevention></prevention>'
    })
    .state('service.safety', {
      url: '/安全への取組み',
      template: '<safety></safety>'
    })
    .state('service.short-trip', {
      url: '/小旅行運行サービス',
      template: '<short-trip></short-trip>'
    })
    .state('service.contribution', {
      url: '/地域への貢献',
      template: '<contribution></contribution>'
    })
    .state('company', {
      abstract: true,
      url: '/会社情報',
      template: '<company></company>'
    })
    .state('company.company-top', {
      url: '/',
      template: '<company-top></company-top>'
    })
    .state('company.covid-notice', {
      url: '/COVID19お知らせ',
      template: '<covid-notice></covid-notice>'
    })
    .state('company.statement', {
      url: '/トップメッセージ',
      template: '<statement></statement>'
    })
    .state('company.about', {
      url: '/会社概要',
      template: '<about></about>'
    })
    .state('company.access', {
      url: '/アクセス',
      template: '<access></access>'
    })
    .state('company.group', {
      url: '/グループ',
      template: '<group></group>'
    })
    .state('recruit', {
      onEnter: $window => {
        $window.open('http://www.mane-job.com/search/detail.php?job_offer_id=2335', '_self');
      }
    })
    .state('others', {
      url: '/その他のビジネス',
      template: '<others></others>'
    });
}



// WEBPACK FOOTER //
// ./client/app/main/main.routes.js